import Icon from '../components/Icon.vue'

Icon.register({
  'dolly-flatbed': {
    width: 640,
    height: 512,
    paths: [
      {
        d: 'M208 320c-8.8 0-16-7.2-16-16v-256c0-8.8 7.2-16 16-16h144v128l48-32 48 32v-128h144c8.8 0 16 7.2 16 16v256c0 8.8-7.2 16-16 16h-384zM624 384c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16h-82.8c1.7 5 2.9 10.4 2.9 16 0 26.5-21.5 48-48 48s-48-21.5-48-48c0-5.6 1.1-11 2.9-16h-197.9c1.7 5 2.9 10.4 2.9 16 0 26.5-21.5 48-48 48s-48-21.5-48-48c0-5.6 1.1-11 2.9-16h-82.9c-8.8 0-16-7.2-16-16v-368h-48c-8.8 0-16-7.2-16-16v-32c0-8.8 7.2-16 16-16h96c8.8 0 16 7.2 16 16v368h496z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/dolly-flatbed.js
// module id = 1277
// module chunks = 0